var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getIsShowReportSettingReportType
    ? _c(
        "div",
        {
          staticClass: "modal fade",
          class: [
            "modal fade",
            {
              show: _vm.getIsShowReportSettingReportType,
              "d-block": _vm.getIsShowReportSettingReportType,
            },
          ],
          staticStyle: { display: "block", "overflow-y": "scroll" },
          attrs: {
            id: "go-setting-report",
            "data-backdrop": "static",
            tabindex: "-1",
            "aria-hidden": "true",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog go-modal-prompt" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _vm.isForReportDetail
                  ? _c("div", { staticClass: "go-text-wrap" }, [
                      _c("div", { staticClass: "modal-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.reportSetting.header.title." +
                                _vm.formData.reportPattern
                            )
                          )
                        ),
                      ]),
                    ])
                  : _c("div", { staticClass: "go-text-wrap" }, [
                      _c("div", { staticClass: "modal-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.reportSetting.header.briefing.title"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.reportSetting.header.briefing.smallText"
                            )
                          )
                        ),
                      ]),
                    ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-icon close",
                    class: _vm.isLoading ? "input-disable" : "",
                    attrs: {
                      id: "closePopupReportDetailSetting",
                      disabled: _vm.isLoading,
                      type: "button",
                      "data-dismiss": "modal",
                    },
                    on: { click: _vm.handleClosePopup },
                  },
                  [_vm._m(0)]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "go-panel go-panel-createSet" }, [
                  _c("div", { staticClass: "go-panel-header" }, [
                    _c("div", { staticClass: "go-text-wrap" }, [
                      _c("div", { staticClass: "go-panel-title" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "briefing.popup.createBriefing.reportTypeSelect.top.title." +
                                  _vm.formData.reportPattern
                              )
                            ) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "go-help-text",
                          staticStyle: { color: "#9a9a9a" },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "briefing.popup.createBriefing.reportTypeSelect.top.requiredMessage." +
                                    _vm.formData.reportPattern
                                )
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-panel-body" }, [
                    _c(
                      "div",
                      { staticClass: "go-createSet-list" },
                      [
                        _vm.formData.reportPattern === "REPORT"
                          ? [
                              _c(
                                "div",
                                { staticClass: "go-list-item go-form-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox custom-control-inline",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: "daily-checkbox",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.formData.reportType ===
                                            _vm.REPORT_TYPES.DAILY,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectType(
                                              _vm.REPORT_TYPES.DAILY
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "daily-checkbox" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionName.dailyReport"
                                                )
                                              ) +
                                              "\n                      "
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.smallText.dailyReport"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.formData.reportStyle["DAILY"],
                                          expression:
                                            "formData.reportStyle['DAILY']",
                                        },
                                      ],
                                      staticClass: "go-form-control",
                                      class: {
                                        "input-disable":
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.DAILY,
                                      },
                                      attrs: {
                                        disabled:
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.DAILY,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.formData.reportStyle,
                                            "DAILY",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BUSINESS,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.business"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BLOG,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.essay"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "go-list-item go-form-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox custom-control-inline",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: "product-review-checkbox",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.formData.reportType ===
                                            _vm.REPORT_TYPES.PRODUCT_REVIEW,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectType(
                                              _vm.REPORT_TYPES.PRODUCT_REVIEW
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for: "product-review-checkbox",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionName.productReviewReport"
                                                )
                                              ) +
                                              "\n                      "
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.smallText.productReviewReport"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.formData.reportStyle[
                                              "PRODUCT_REVIEW"
                                            ],
                                          expression:
                                            "formData.reportStyle['PRODUCT_REVIEW']",
                                        },
                                      ],
                                      staticClass: "go-form-control",
                                      class: {
                                        "input-disable":
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.PRODUCT_REVIEW,
                                      },
                                      attrs: {
                                        disabled:
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.PRODUCT_REVIEW,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.formData.reportStyle,
                                            "PRODUCT_REVIEW",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BUSINESS,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.business"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BLOG,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.essay"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "go-list-item go-form-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox custom-control-inline",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: "investment-checkbox",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.formData.reportType ===
                                            _vm.REPORT_TYPES.INVESTMENT,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectType(
                                              _vm.REPORT_TYPES.INVESTMENT
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "investment-checkbox" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionName.investmentReport"
                                                )
                                              ) +
                                              "\n                      "
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.smallText.investmentReport"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.formData.reportStyle[
                                              "INVESTMENT"
                                            ],
                                          expression:
                                            "formData.reportStyle['INVESTMENT']",
                                        },
                                      ],
                                      staticClass: "go-form-control",
                                      class: {
                                        "input-disable":
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.INVESTMENT,
                                      },
                                      attrs: {
                                        disabled:
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.INVESTMENT,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.formData.reportStyle,
                                            "INVESTMENT",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BUSINESS,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.business"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BLOG,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.essay"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "go-list-item go-form-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox custom-control-inline",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: "in-depth-checkbox",
                                          disabled:
                                            !_vm.isAvailableIndepthReport,
                                        },
                                        domProps: {
                                          checked:
                                            _vm.formData.reportType ===
                                            _vm.REPORT_TYPES.INDEPTH_DAILY,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectType(
                                              _vm.REPORT_TYPES.INDEPTH_DAILY
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "in-depth-checkbox" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionName.inDepthReport"
                                                )
                                              ) +
                                              "\n                      "
                                          ),
                                          !_vm.isAvailableIndepthReport
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#fd7e14",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        (" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "briefing.popup.createBriefing.reportTypeSelect.alert.inDepthReport"
                                                        )
                                                      ) +
                                                      ")\n                      "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.smallText.inDepthReport"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.formData.reportStyle[
                                              "INDEPTH_DAILY"
                                            ],
                                          expression:
                                            "formData.reportStyle['INDEPTH_DAILY']",
                                        },
                                      ],
                                      staticClass:
                                        "go-form-control go-select-one-child",
                                      class: {
                                        "input-disable":
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.INDEPTH_DAILY,
                                      },
                                      attrs: {
                                        disabled:
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.INDEPTH_DAILY,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.formData.reportStyle,
                                            "INDEPTH_DAILY",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BUSINESS,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.business"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.formData.reportPattern === "JOURNAL_NOTE"
                          ? [
                              _c(
                                "div",
                                { staticClass: "go-list-item go-form-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox custom-control-inline",
                                      attrs: { hidden: "" },
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: "journalist-checkbox",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.formData.reportType ===
                                            _vm.REPORT_TYPES.JOURNAL_NOTE,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectType(
                                              _vm.REPORT_TYPES.JOURNAL_NOTE
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "journalist-checkbox" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionName.journal"
                                                )
                                              ) +
                                              "\n                      "
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.smallText.journal"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.formData.reportStyle[
                                              "JOURNAL_NOTE"
                                            ],
                                          expression:
                                            "formData.reportStyle['JOURNAL_NOTE']",
                                        },
                                      ],
                                      staticClass: "go-form-control",
                                      class: {
                                        "input-disable":
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.JOURNAL_NOTE,
                                      },
                                      attrs: {
                                        disabled:
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.JOURNAL_NOTE,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.formData.reportStyle,
                                            "JOURNAL_NOTE",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BUSINESS,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.business"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BLOG,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.essay"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.formData.reportPattern === "SOCIAL_MEDIA"
                          ? [
                              _c(
                                "div",
                                { staticClass: "go-list-item go-form-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox custom-control-inline",
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          type: "checkbox",
                                          id: "social-media-checkbox",
                                        },
                                        domProps: {
                                          checked:
                                            _vm.formData.reportType ===
                                            _vm.REPORT_TYPES.SOCIAL_MEDIA,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectType(
                                              _vm.REPORT_TYPES.SOCIAL_MEDIA
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for: "social-media-checkbox",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionName.socialMedia"
                                                )
                                              ) +
                                              "\n                      "
                                          ),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.smallText.socialMedia"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.formData.reportStyle[
                                              "SOCIAL_MEDIA"
                                            ],
                                          expression:
                                            "formData.reportStyle['SOCIAL_MEDIA']",
                                        },
                                      ],
                                      staticClass: "go-form-control",
                                      class: {
                                        "input-disable":
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.SOCIAL_MEDIA,
                                      },
                                      attrs: {
                                        disabled:
                                          _vm.formData.reportType !==
                                          _vm.REPORT_TYPES.SOCIAL_MEDIA,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.formData.reportStyle,
                                            "SOCIAL_MEDIA",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.BLOG,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.blog"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.FACEBOOK,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.facebook"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.X,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.x"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: _vm.REPORT_STYLES.YOUTUBE,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.youtube"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.isForReportDetail
                  ? _c("div", { staticClass: "go-panel go-panel-createSet" }, [
                      _c("div", { staticClass: "go-panel-header" }, [
                        _c("div", { staticClass: "go-text-wrap" }, [
                          _c("div", { staticClass: "go-panel-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "briefing.popup.reportSetting.regenerateOption.title"
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-panel-body" }, [
                        _c("div", { staticClass: "go-form-group" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "custom-control custom-radio go-form-check-inline",
                            },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  disabled: _vm.isLoading,
                                  type: "radio",
                                  id: "go-option-public",
                                  name: "updateOptions",
                                },
                                domProps: {
                                  checked:
                                    _vm.formData.updateOptions === "UPDATE",
                                },
                                on: {
                                  click: function () {
                                    return (_vm.formData.updateOptions =
                                      "UPDATE")
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-control-label",
                                  attrs: { for: "go-option-public" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "briefing.popup.reportSetting.regenerateOption.update." +
                                          _vm.formData.reportPattern
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "custom-control custom-radio go-form-check-inline",
                            },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  disabled: _vm.isLoading,
                                  type: "radio",
                                  id: "go-option-private",
                                  name: "updateOptions",
                                },
                                domProps: {
                                  checked:
                                    _vm.formData.updateOptions === "CREATE",
                                },
                                on: {
                                  click: function () {
                                    return (_vm.formData.updateOptions =
                                      "CREATE")
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-control-label",
                                  attrs: { for: "go-option-private" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "briefing.popup.reportSetting.regenerateOption.create." +
                                          _vm.formData.reportPattern
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "go-panel go-info-box" }, [
                  _c("ul", { staticClass: "go-info-list" }, [
                    _c("li", { staticClass: "go-list-item" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "briefing.popup.reportSetting.guidance.firstText"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "go-list-item" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "briefing.popup.reportSetting.guidance.secondText"
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-default go-btn-lg",
                    attrs: {
                      disabled: _vm.isLoading,
                      type: "button",
                      "data-dismiss": "modal",
                    },
                    on: { click: _vm.handleClosePopup },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "briefing.popup.updateBriefing.footer.cancelButtonText"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.isForReportDetail
                  ? _c(
                      "button",
                      {
                        staticClass: "btn go-btn-primary go-btn-lg",
                        attrs: {
                          disabled: _vm.isLoading || !_vm.formValid,
                          type: "button",
                        },
                        on: { click: _vm.handleCallAPIToUpdateOrCreateReport },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "briefing.popup.reportSetting.footer.buttonCreate.labelText"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn go-btn-primary go-btn-lg",
                        attrs: {
                          disabled: _vm.isLoading || !_vm.formValid,
                          type: "button",
                        },
                        on: { click: _vm.updateReportsForBriefing },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "briefing.popup.reportSetting.footer.buttonSave.labelText"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "go-tooltip-area",
        attrs: { "data-toggle": "tooltip", title: "Close" },
      },
      [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }